import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerCancelAnytimeViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    cancelAnyTimeTitle: string;
    cancelAnyTimeDesc: string;
  };
};

const BrokerCancelAnytimeView = (props: BrokerCancelAnytimeViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box
        className={clsx(
          `flex min-h-[180px] flex-col justify-center space-y-4 rounded-3xl bg-[#05004F] bg-[url('https://storage.googleapis.com/jove-public-images/website/landing-pages/universal/broker-cancel-anytime.png')] bg-cover px-10`,
          isMobileLayout ? 'w-full py-5' : 'w-[960px]'
        )}
      >
        <Typography variant="h4" className="font-black text-white">
          {info?.cancelAnyTimeTitle}
        </Typography>
        <Typography variant="h6" className="font-medium text-white">
          {info?.cancelAnyTimeDesc}
        </Typography>
      </Box>
    </Box>
  );
};

export default BrokerCancelAnytimeView;
